<dx-popup
  [width]="500"
  [(visible)]="showModal"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'TEXT-TEMPLATES.SAVE-AS-TEMPLATE' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  (onHidden)="close()"
>
  <div *dxTemplate="let data of 'content'">
    <dx-form
      #templateForm
      [formData]="formData"  
      labelMode="hidden"
    >
      <dxi-item 
        dataField="name"
        [editorOptions]="{ 
          placeholder: ('COMMON.FIELDS.NAME' | translate) 
        }"
      >
        <dxi-validation-rule
          type="required"
          [message]="'VALIDATIONS.NAME-REQUIRED' | translate"
        ></dxi-validation-rule>
      </dxi-item>

      <dxi-item>
        <div *dxTemplate>
          <div class="button-container">
            <dx-button 
              [text]="'COMMON.BACK' | translate" 
              icon="back"
              class="action-btn"
              type="default"
              stylingMode="contained"
              (onClick)="close()"
            ></dx-button>
            <dx-button 
              [text]="'COMMON.SAVE' | translate" 
              class="action-btn"
              type="normal"
              stylingMode="contained"
              (onClick)="onSaveClick()"
            ></dx-button>
          </div>
        </div>
      </dxi-item>
    </dx-form>
  </div>
</dx-popup>